<template>
	<div>
		<el-dialog
			:center="true"
			:visible.sync="show"
			:close-on-click-modal="false"
			:modal="true"
			width="auto"
			height="auto"
			:append-to-body="true"
			class="dialog"
		>
			<div class="box" v-loading="loading">
				<div class="b_head">
					<span>{{ lang.Add_Application }}</span>
					<svg
						@click="close()"
						t="1748587270371"
						class="icon"
						viewBox="0 0 1024 1024"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						p-id="5023"
						width="200"
						height="200"
					>
						<path
							d="M0 0h1024v1024H0z"
							fill="#FF0033"
							fill-opacity="0"
							p-id="5024"
						></path>
						<path
							d="M240.448 168l2.346667 2.154667 289.92 289.941333 279.253333-279.253333a42.666667 42.666667 0 0 1 62.506667 58.026666l-2.133334 2.346667-279.296 279.210667 279.274667 279.253333a42.666667 42.666667 0 0 1-58.005333 62.528l-2.346667-2.176-279.253333-279.253333-289.92 289.962666a42.666667 42.666667 0 0 1-62.506667-58.005333l2.154667-2.346667 289.941333-289.962666-289.92-289.92a42.666667 42.666667 0 0 1 57.984-62.506667z"
							fill="#111111"
							p-id="5025"
						></path>
					</svg>
				</div>
				<div class="b_main">
					<div class="b_m_appArea">
						<div class="b_m_aa_top">
							<div class="b_m_aa_t_app" v-if="selectData">
								<img :src="selectData.json.icon" alt="" />
								<div>
									<div>{{ selectData.name }}</div>
									<span>{{ selectData.detail }}</span>
								</div>
							</div>
							<div class="b_m_aa_t_addAppBox" @click="openAppDialog" v-else>
								<span>+</span>
							</div>
							<el-button
								type="primary"
								size="small"
								@click="openAppDialog"
								>{{ lang.select_app }}</el-button
							>
						</div>
						<div class="b_m_aa_bottom">
							<!-- <span>{{ lang.app_name }}：</span> -->
							<el-input
								v-model="appName"
								class="b_m_aa_b_input_appName"
								:placeholder="lang.please_enter + lang.app_name"
							>
							<template slot="prepend">{{ lang.app_name }}</template>
						</el-input>
						</div>
					</div>
					<div class="b_m_selectClass">
						<div class="wb_j_box_btn" @click="openClassDialog()">
							<div class="wb_j_box_title">{{ lang.teaching_class }}</div>
							<div class="wb_j_box_btn_c">
								<el-tooltip
									effect="dark"
									:content="getListClassC(classList)"
									placement="top"
									v-if="classList.length"
									popper-class="text_tooltip2"
								>
									<div class="wb_j_box_span">
										{{ getListClassC(classList) }}
									</div>
								</el-tooltip>
								<div v-else class="wb_j_box_span">
									{{ lang.please_select + lang.teaching_class }}
								</div>
								<div class="wb_j_box_arrow"></div>
							</div>
						</div>

						<div class="wb_j_box_btn" @click="openTeacherDialog()">
							<div class="wb_j_box_title">{{ lang.collaborate_with_the_teacher }}</div>
							<div class="wb_j_box_btn_c">
								<!-- <el-tooltip effect="dark" :content="getListMan2(checkboxList3)" placement="top"
                  v-if="checkboxList3.length" popper-class="text_tooltip2"> -->
								<div class="wb_j_box_span" v-if="teacherList.length">
									{{ getListMan2(teacherList) }}
								</div>
								<!-- </el-tooltip> -->
								<div v-else class="wb_j_box_span">{{ lang.collaborate_with_the_teacher }}</div>
								<div class="wb_j_box_arrow"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="b_bottom">
					<el-button size="small" @click="close()">{{ lang.cancel }}</el-button>
					<el-button size="small" type="primary" @click="submit"
						>{{ lang.confirm_to_add }}</el-button
					>
				</div>
				<selectAppDialog
					ref="selectAppDialogRef"
					@success="selectAppDialogSuccess"
				/>
        
				<addClassDialog
					ref="addClassDialogRef"
					@success="addClassDialogSuccess"
				/>
				<addTeacherDialog
					ref="addTeacherDialogRef"
					@success="addTeacherDialogSuccess"
				/>
        <appDialog ref="appDialogRef" @success="appDialogSuccess"/>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import selectAppDialog from "./selectAppDialog.vue";
import addClassDialog from "./addClassDialog.vue";
import addTeacherDialog from "./addTeacherDialog.vue";
import appDialog from './appDialog.vue'
export default {
	components: {
		selectAppDialog,
		addClassDialog,
		addTeacherDialog,
    appDialog
	},
	data() {
		return {
			loading: false,
			show: false,
			selectData: null,
			appName: "",
			classList: [],
			teacherList: [],
		};
	},
	computed: {
		getListClassC() {
			return (list) => {
				let _c2 = [];
				let grade = this.$refs.addClassDialogRef.grade;
				if (grade.length) {
					for (var j = 0; j < list.length; j++) {
						let c = list[j];
						for (var i = 0; i < grade.length; i++) {
							if (grade[i].id == c) {
								_c2.push(grade[i].name);
								break;
							}
						}
					}
				}
				return grade.length ? _c2.join("、") : "";
			};
		},
		getListMan2() {
			return (list) => {
				console.log("getListMan2", list);
				let _people2 = [];
				let ManAarray = this.$refs.addTeacherDialogRef.teacherJuri;
				if (ManAarray.length) {
					list.slice(0, 10).forEach((people) => {
						let name =
							ManAarray.find(
								(man) => man.userid === people && people !== this.user.userId
							).name || "";
						if (name) {
							_people2.push(name);
						}
					});
				}

				return _people2.join("、");
			};
		},
	},
	methods: {
		open() {
			this.init();
			this.loading = false;
			this.show = true;
		},
		close() {
			this.show = false;
			this.init();
		},
		init() {
			this.selectData= null;
			this.appName= "";
			this.classList= [];
			this.teacherList= [];
		},
		submit() {
			this.loading = true;
			let params = [{
				uid:this.user.userId,
				appId:this.selectData.id,
				appName:this.appName,
				summary:'',
				teacher:this.teacherList.join(","),
				grade:this.classList.join(","),
				status:"0",
				analysis:JSON.stringify(""),
				json:JSON.stringify(""),
			}]

			this.ajax.post(this.$store.state.api+'insert_teachingMode',params).then(res=>{
				console.log(res)
				if(res.data===1){
					this.$message.success(this.lang.addSuccessfully)
					this.$emit("success")
				}else{
					this.$message.error(this.lang.addFailure)
				}
				this.loading = false;
			}).catch(err=>{
				console.log(err)
				this.loading = false;
				this.$message.error(this.lang.addFailure)
			})
			// let _form = {
			// 	appId: this.selectData.id,
			// 	appName: this.appName,
			// 	classId: this.classList.join(","),
			// 	teacherId: this.teacherList.join(","),
			// };

			// this.$emit("success", _form);
		},
		openSelectAppDialog() {
			this.$refs.selectAppDialogRef.open(
				this.selectData ? this.selectData.id : null
			);
		},
    openAppDialog(){
			this.$refs.appDialogRef.openG(
				this.selectData ? this.selectData : {},2
			);
		},
		selectAppDialogSuccess(data) {
			this.selectData = data;
			this.appName = data.name;
			this.$refs.selectAppDialogRef.close();
		},
    appDialogSuccess(data){
      console.log('data',data)
      this.selectData = data.data;
			this.appName = data.data.name;

    },
		openClassDialog() {
			this.$refs.addClassDialogRef.open(this.classList ? this.classList : []);
		},
		addClassDialogSuccess(data) {
			this.classList = data;
			this.$refs.addClassDialogRef.close();
		},
		openTeacherDialog() {
			this.$refs.addTeacherDialogRef.open(
				this.teacherList ? this.teacherList : []
			);
		},
		addTeacherDialogSuccess(data) {
			this.teacherList = data;
			this.$refs.addTeacherDialogRef.close();
		},
	},
};
</script>

<style scoped>
.dialog >>> .el-dialog {
	width: 900px !important;
	border-radius: 8px;
	padding: 0;
	background-color: #fff;
	overflow: hidden;
}

.dialog >>> .el-dialog__body {
	width: 900px !important;
	height: auto;
	flex-shrink: 0;
	padding: 0;
	box-sizing: border-box;
	overflow: auto;
}

.dialog >>> .el-dialog__header {
	display: none !important;
}

.box {
	width: 900px;
	height: 500px;
	background: #fafafa;
	border-radius: 15px;
	box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05),
		0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
}

.b_head {
	width: 100%;
	height: 50px;
	border-radius: 15px 15px 0 0;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	padding: 0 20px;
}

.b_head > span {
	font-size: 18px;
	font-weight: bold;
	color: #000;
}

.b_head > img {
	width: 20px;
	height: 20px;
	cursor: pointer;
}

.b_head > svg {
	width: 20px;
	height: 20px;
	cursor: pointer;
}

.b_main {
	width: 100%;
	height: calc(100% - 50px - 70px);
	background: #fafafa;
	padding: 20px 20px 0 20px;
	box-sizing: border-box;
}

.b_bottom {
	width: 100%;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	box-sizing: border-box;
	padding: 0 20px;
}

.b_m_appArea {
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.b_m_aa_top {
	width: 100%;
	height: 130px;
}

.b_m_aa_t_app {
	width: 100%;
	height: 80px;
	display: flex;
	justify-content: center;

	margin-bottom: 10px;
}

.b_m_aa_t_addAppBox{
	width: 150px;
	height: 80px;
	display: flex;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	border-radius: 10px;
	border: #ccc 1px dashed;
	margin-bottom: 10px;
	font-size: 24px;
	color: #ccc;
	cursor: pointer;
}

.b_m_aa_t_app > img {
	width: 80px;
	height: 80px;
	margin-right: 15px;
	object-fit: cover;
	border-radius: 4px;
}

.b_m_aa_t_app > div {
	width: calc(100% - 80px - 15px);
	height: 80px;
}

.b_m_aa_t_app > div > div {
	max-width: 100%;
	font-size: 18px;
	font-weight: bold;
	color: #000;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.b_m_aa_t_app > div > span {
	display: block;
	max-width: 100%;
	margin-top: 5px;
	font-size: 14px;
	color: #666;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.b_m_aa_bottom {
	width: 100%;
	height: auto;
	margin-top: 10px;
}

.b_m_aa_bottom > span {
	font-size: 16px;
	color: #000;
	margin-bottom: 10px;
	display: block;
}

.wb_j_box_btn {
	width: 100%;
	display: flex;
	height: 40px;
	border: 1.5px solid #cad1dc;
	border-radius: 4px;
	box-sizing: border-box;
	align-items: center;
	font-size: 14px;
	cursor: pointer;
	overflow: hidden;
	margin-top: 20px;
}

.wb_j_box_btn:hover {
	border: 1.5px solid #0061ff;
}

.wb_j_box_title {
	background: #f0f4fa;
	height: 100%;
	line-height: 40px;
	width: 90px;
	text-align: center;
	color: #060e17;
	border-right: 1.5px solid #cad1dc;
	box-sizing: border-box;
}

.wb_j_box_btn_c {
	width: calc(100% - 90px);
	padding: 0 35px 0 10px;
	box-sizing: border-box;
	position: relative;
}

.wb_j_box_span {
	width: 100%;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	word-wrap: break-word;
	color: #717c8d;
}

.wb_j_box_arrow {
	content: "";
	width: 14px;
	height: 14px;
	background: url(../../../assets/img/teachingMode/u_arrow.png);
	background-size: 100% 100%;
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
}

.b_m_aa_b_input_appName>>>.el-input-group__prepend{
	background-color: #F0F4FA !important;
	color: #000 !important;
	border-color: #cad1dc !important;
	width: 90px !important;
	padding: 0 !important;
	text-align: center;
}
</style>
